import React from "react";
import { Building2 } from "lucide-react";
import DioceseSelector from "@/components/DioceseSelector";
import BackofficeShell from "@/components/layout/BackofficeShell";
import { LayoutDashboard, School, Receipt, ScrollText } from "lucide-react";

const navItems = [
  { href: "/economat", label: "Tableau de bord", icon: LayoutDashboard },
  { href: "/economat/ecoles", label: "Écoles du diocèse", icon: School },
  { href: "/economat/paiements", label: "Paiements", icon: Receipt },
  { href: "/economat/audit", label: "Journal d'audit", icon: ScrollText },
];

export default function EconomatShell({ children }: { children: React.ReactNode }) {
  return (
    <BackofficeShell
      title="CATHO SCHOOL · Économat Diocésain"
      icon={Building2}
      navItems={navItems}
      selector={<DioceseSelector />}
    >
      {children}
    </BackofficeShell>
  );
}
